import React from 'react';
import {
  FiTrendingUp,
  FiAlertCircle,
  FiStar,
  FiAlertTriangle,
  FiArrowRight,
} from 'react-icons/fi';
import styles from '../DashboardOverviewNew.module.scss';

const ICON_MAP = {
  'trending-up': FiTrendingUp,
  alert: FiAlertCircle,
  star: FiStar,
  warning: FiAlertTriangle,
};

export const AIInsights = ({ data }) => (
  <div className={styles.quarterCard}>
    <div className={styles.cardHeader}>
      <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
        <span className={styles.cardTitle}>AI Insights</span>
        <span className={styles.betaBadge}>Beta</span>
      </div>
    </div>

    <div className={styles.insightsList}>
      {data.map((item) => {
        const Icon = ICON_MAP[item.iconType] || FiAlertCircle;
        return (
          <div key={item.id} className={styles.insightItem}>
            <div
              className={styles.insightIconWrapper}
              style={{ backgroundColor: item.iconBg }}
            >
              <Icon size={15} color={item.iconColor} />
            </div>
            <div className={styles.insightContent}>
              <span className={styles.insightTitle}>{item.title}</span>
              <span className={styles.insightDesc}>{item.desc}</span>
            </div>
          </div>
        );
      })}
    </div>

    <button className={styles.viewLink}>
      View all insights <FiArrowRight size={13} />
    </button>
  </div>
);
